<!--
 * @Author: wbf
 * @LastEditTime: 2023-01-06 17:55:49
 * @Description: 校验个人信息
-->
<template>
	<div>
		<NavBar
			:title="$t(`webapp.menus.${$route.meta.field}`)"
			:left-arrow="$route.meta.isShowArrow"
			@click-left="$router.back()"
			nav-bar-icon-color="#000"
			class="navbarSelf"
		></NavBar>

		<div class="box">
			<Form @submit="onSubmit" class="vertical_self_form">
				<Field
					v-model="form.username"
					name="username"
					:label="`${$t('webapp.activate.account')}${basicSetInfo.sfzjh == 1 ? `/${$t('login.activate.offer_placeholder')}` : ''}`"
					:placeholder="`${$t('login.username_placeholder')}${basicSetInfo.sfzjh == 1 ? `/${$t('login.activate.offer_placeholder')}` : ''}`"
					:show-error-message="false"
					:scroll-to-error="true"
					:rules="[{ required: true }]"
				/>
				<Field
					v-model="form.displayName"
					name="displayName"
					:label="$t('webapp.activate.name')"
					:placeholder="$t('login.activate.name_placeholder')"
					:show-error-message="false"
					:scroll-to-error="true"
					:rules="[{ required: true }]"
				/>
				<Field
					v-model="form.idCardNo"
					name="idCardNo"
					:placeholder="$t('base.input')"
					:show-error-message="false"
					:scroll-to-error="true"
					:rules="[{ required: true }]"
				>
					<template #label>
						<div class="code_type_label" @click="codeTypeChange">
							<span>{{ codeList.find((o) => o.value == form.idType).text }}</span>
							<Icon class="c_l_s_right" name="arrow" />
						</div>
					</template>
				</Field>

				<Field
					v-model="form.captcha"
					name="captcha"
					:label="$t('base.captcha.label')"
					:placeholder="$t('base.captcha.placeholder')"
					:show-error-message="false"
					:scroll-to-error="true"
					:rules="[{ required: true }]"
				>
					<template #button>
						<img class="img" :src="validMaskImage" alt="" @click="getValidMask" />
					</template>
				</Field>

				<div style="margin-top: 30px">
					<Button round block type="info" native-type="submit">{{ $t("base.btn.next_step") }}</Button>
				</div>
				<!-- 选择身份类型 -->
				<Popup v-model="codeTypePicker" position="bottom">
					<Picker
						show-toolbar
						:columns="codeList"
						:default-index="defaultType"
						@confirm="codeTypePickerConfirm"
						@cancel="codeTypePicker = false"
					/>
				</Popup>
			</Form>
		</div>
	</div>
</template>

<script>
import { Field, Icon, Form, Button, Popup, Picker, NavBar } from "vant";
import { commonAPI } from "@/apis";
import { toast } from "@/utils/toast";

export default {
	name: "ActivateVerifyInfo",
	components: { Field, Icon, Form, Button, Popup, Picker, NavBar },
	data() {
		return {
			validMaskImage: "",
			form: { idType: "1" },
			codeList: [
				{ text: this.$t("base.idCard"), value: "1" },
				{ text: this.$t("base.passport"), value: "2" },
				{ text: this.$t("base.gatCard"), value: "3" },
				{ text: this.$t("base.other"), value: "4" },
			],
			defaultType: 0,
			codeTypePicker: false,
			basicSetInfo: {},
		};
	},
	created() {
		this.getValidMask();
		this.basicSetInfo = JSON.parse(sessionStorage.getItem("BASIC_SET_INFO"));
	},
	methods: {
		// 得到验证码图片
		async getValidMask() {
			const { code, data } = await commonAPI.getAction("/user/active/captcha");
			if (code === 0) {
				this.validMaskImage = data.image;
				this.form.captchaKey = data.captchaKey;
			}
		},
		// 选择身份类型
		codeTypeChange() {
			this.codeTypePicker = true;
			this.$nextTick(() => {
				this.defaultType = Number(this.form.idType) - 1;
			});
		},
		// 选择身份类型确认
		codeTypePickerConfirm(obj) {
			this.form.idType = obj.value;
			this.codeTypePicker = false;
		},
		async onSubmit(values) {
			// 第一步先校验好个人信息成功后带当前的参数跳转到绑定邮箱页面
			console.log("submit", this.form);

			let params = { ...this.form };
			const { code, data, message } = await commonAPI.postAction("/user/active/checkUserInfo", params);
			if (code == 0) {
				let obj = { username: this.form.username, secretKey: data };
				localStorage.setItem("ACTIVATE_INFO", JSON.stringify(obj));
				toast(message);
				let url = this.$route.query.id == 1 ? "/mbindEmail" : this.$route.query.id == 2 ? "/mbindPhone" : "";
				this.$router.push({
					path: url,
					query: { type: "activate" }, //表示类型是账号激活
				});
			} else {
				this.getValidMask();
				toast(message);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/base.scss";

.box {
	height: 100vh;
	padding: 10px 0;
	.code_type_label {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.img {
		width: 28vw;
		height: 36px;
	}
}
</style>
